import loaded from "@/scripts/helpers/loaded.js";

loaded(function() {
    document.querySelectorAll('[data-section-type="recently-shopped"]').forEach((section) => {
        const sectionId = section.getAttribute('data-boost-section');
        if (!sectionId) {
            return;
        }

        function activateRecentSection() {
            const slides = document.querySelectorAll(`#boost-sd-widget-${sectionId} .slick-slide`);
            if(slides.length < 4){
                const recentSection = document.querySelector(`#shopify-section-${sectionId} .recently_shopped`);
                if (recentSection) {
                    recentSection.style.display = 'none';
                }
            }
        }

        function onElementLoadedRecentlyShopped(selector, callback) {
            setTimeout(function() {
                let interval = setInterval(function () {
                    if (document.querySelectorAll(selector).length) {
                        clearInterval(interval);
                        callback();
                    }
                }, 100);
            }, 1000);

            setTimeout(function(){
                updateWidgetRecentlyShopped();
            }, 2000);
        }

        function updateWidgetRecentlyShopped() {
            let documentWidth = window.innerWidth;

            const nextButtons = document.querySelectorAll(`.best-product-section #boost-sd-widget-${sectionId} .boost-sd__next-button .boost-sd__button-icon`);
            const prevButtons = document.querySelectorAll(`.best-product-section #boost-sd-widget-${sectionId} .boost-sd__prev-button .boost-sd__button-icon`);

            if(documentWidth < 700) {
                nextButtons.forEach(button => button.innerHTML = '');
                prevButtons.forEach(button => button.innerHTML = '');
            } else {
                nextButtons.forEach(button => {
                    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                <path d="M1.50004 11C1.50004 11 6.49999 7.31756 6.5 5.99996C6.50001 4.68237 1.5 1 1.5 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;
                });
                prevButtons.forEach(button => {
                    button.innerHTML = `<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.49996 11C6.49996 11 1.50001 7.31756 1.5 5.99996C1.49999 4.68237 6.5 1 6.5 1" stroke="#A7A8A9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`;
                });
            }
        }

        onElementLoadedRecentlyShopped(`#boost-sd-widget-${sectionId} .boost-sd__slide .boost-sd__product-price-content`, function() {
            updateWidgetRecentlyShopped();
            const buttons = document.querySelectorAll(`#boost-sd-widget-${sectionId} .boost-sd__button--circle, #boost-sd-widget-${sectionId} .boost-sd__next-button, #boost-sd-widget-${sectionId} .boost-sd__prev-button`);
            buttons.forEach(button => {
                button.addEventListener('click', function(){
                    updateWidgetRecentlyShopped();
                });
            });
        });
        setTimeout(function() {
            activateRecentSection();
            setTimeout(function() {
                activateRecentSection();
            }, 2000);
        }, 3000);
    });
});
